import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mark'
})
export class MarkPipe implements PipeTransform
{
    public transform(value: string, target: string): string
    {
        const regex = new RegExp(`(${this.escapeForRegex(target)})`, 'gi');
        return value.replace(regex, '<mark>$1</mark>');
    }

    public escapeForRegex(string: string): string
    {
        return string.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }
}
